import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import PromoMaterials from '../../components/affiliate/PromoMaterials'
import AffiliateHeader from '../../components/affiliate/AffiliateHeader'

export default function PromoMaterialsPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <AffiliateHeader />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-4 sm:py-8">
        <PromoMaterials />
      </main>
    </div>
  )
}
